import React from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { convertImage } from 'appSrc/utils/random';
import FavoriteBadge from 'appSrc/v5/components/FavoriteBadge';
import TextTruncate from 'react-text-truncate';
import style from './styles/style.module.css';


const scalePrice = ( p ) => {
    p = parseFloat( p );
    if( Number.isNaN( p ) ) { return 0; }
    p = Math.ceil( p );
    p = parseInt( p );
    return p;
};

const PurchaseProductCard = ( props ) => {
    const { product } = props;
    const image = convertImage( product.image );
    const className = `${ style.ProductCardBasic } ${ props.className }`.trim();

    return (
        <div data-id={ product.desireid }
        className={ className } style={ props.style } >
            <div className={ style.slipWrapper }>
                <Link className={ style.hoverSlip }
                to={ `/app/products/${ product.desireid }/${ encodeForURI( product.title ) }` }>
                    <span className={ style.text }>View Product</span>
                </Link>
            </div>
            <Link className={ style.productLink }
            to={ `/app/products/${ product.desireid }/${ encodeForURI( product.title ) }` }>
                <div className={ style.imageWrapper }>
                    <img src={ image } />
                    <div className={ style.priceSlip }>${ scalePrice( product.price ) }</div>
                </div>
                { props.showTitle &&
                    <div className={ style.details }>
                        <TextTruncate text={ product.title }
                        line={ 2 } className={ style.title } />
                    </div>
                }
            </Link>
            <div className={ style.favoriteWrapper }>
                <FavoriteBadge className={ style.favorite }
                type="product"
                item={ product } />
            </div>
        </div>
    );
};
PurchaseProductCard.defaultProps = {
    product: {},
    className: '',
    style: {},
    showTitle: false,
};
PurchaseProductCard.propTypes = {
    product: PropTypes.object.isRequired,
};

export default PurchaseProductCard;
